<template>
  <v-expansion-panel
    @click="$emit('row-selected', account.id)"
    class="expansion-panel"
  >
    <v-expansion-panel-header class="expansion-panel__header">
      <div><slot name="account-type"></slot></div>
      <div>{{ account.email || account.name }}</div>
      <div>
        <slot name="add-btn"></slot>
        <v-menu left :offset-x="true" origin="left top" nudge-top="11">
          <template #activator="{ on }">
            <v-icon v-on="on">icon-more </v-icon>
          </template>
          <ui-button
            @click="$emit('show-delete-dialog', account.id)"
            icon="icon-trash"
            iconColor="red"
          >
            {{ $t("message.common.removeAccount") }}
          </ui-button>
        </v-menu>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-list class="items-list" v-if="$slots['items-list']">
        <slot name="items-list"></slot>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "AccountsExpansionPanelRow",
  props: {
    account: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.items-list {
  border-radius: 25px;
  background-color: $light-4;
  margin-bottom: $spacing * 2;
  padding: 0 $spacing * 2;

  &__no-data {
    @include font-size(14px);
  }
}

.expansion-panel {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include font-size(14px);
    padding: $spacing * 2 $spacing;
    gap: $spacing;

    div {
      flex-grow: 1;
      display: flex;
      align-items: center;
      gap: $spacing;

      &:first-child {
        max-width: 150px;
      }

      &:nth-child(3) {
        max-width: 220px;
        flex-grow: 0;
      }
    }
  }

  &__btn {
    flex-grow: 0;
  }

  box-shadow: none;

  &::before {
    box-shadow: none;
  }

  &::after {
    content: none;
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba($text, 0.1);
  }

  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0;
  }
}
</style>
